export default __webpack_public_path__ + "static/media/ic_matic_16.fa7d7271.svg";